<div class="container-fluid">
  <div class="page-header">
    <div class="row">
      <div class="col-lg-6">
        <div class="page-header-left">
          <h3>{{title}}</h3>
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a [routerLink]="title">
                <app-feather-icons [icon]="'home'"></app-feather-icons>
              </a></li>
            <li class="breadcrumb-item" *ngFor="let breadcrumb of breadcrumbs">{{breadcrumb}}</li>
          </ol>
        </div>
      </div>
      <div class="col-lg-6">
      </div>
    </div>
  </div>
</div>